import { createTheme } from '@mui/material/styles';
import { HEX, FONT_DISPLAY, FONT_MONO, RADIUS, SHADOW } from './tokens';

// MUI's Grid is a 12-column system; every layout in this app is expressed through it.
const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: HEX.side, light: HEX.sideHi, contrastText: '#ffffff' },
    secondary: { main: HEX.mint, contrastText: '#04160e' },
    warning: { main: HEX.gold, contrastText: '#2a2100' },
    error: { main: HEX.crit },
    success: { main: HEX.good },
    background: { default: HEX.cream, paper: HEX.card },
    text: { primary: HEX.ink, secondary: HEX.ink2, disabled: HEX.muted },
    divider: HEX.border,
  },
  breakpoints: { values: { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1536 } },
  shape: { borderRadius: RADIUS },
  spacing: 8,
  typography: {
    fontFamily: FONT_DISPLAY,
    fontSize: 14,
    h1: { fontFamily: FONT_DISPLAY, fontWeight: 700 },
    h2: { fontFamily: FONT_DISPLAY, fontWeight: 700 },
    h3: { fontFamily: FONT_DISPLAY, fontWeight: 700 },
    h4: { fontFamily: FONT_DISPLAY, fontWeight: 700 },
    h5: { fontFamily: FONT_DISPLAY, fontWeight: 600 },
    h6: { fontFamily: FONT_DISPLAY, fontWeight: 600, fontSize: 15 },
    body1: { fontSize: 14, lineHeight: 1.45 },
    body2: { fontSize: 12.5, lineHeight: 1.45 },
    button: { textTransform: 'none', fontWeight: 500 },
    // custom variant used for every uppercase mono micro-label in the design
    overline: {
      fontFamily: FONT_MONO,
      fontSize: 10.5,
      letterSpacing: '.08em',
      textTransform: 'uppercase',
      lineHeight: 1.4,
      color: HEX.muted,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: { backgroundColor: HEX.cream, color: HEX.ink },
      },
    },
    MuiPaper: {
      defaultProps: { elevation: 0 },
      styleOverrides: {
        root: { backgroundImage: 'none' },
      },
    },
    MuiButtonBase: { defaultProps: { disableRipple: false } },
    MuiTooltip: {
      styleOverrides: {
        tooltip: { background: '#0c281d', fontSize: 12, fontFamily: FONT_DISPLAY },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          background: HEX.card2,
          fontSize: 13,
          '& fieldset': { borderColor: HEX.border },
          '&:hover fieldset': { borderColor: HEX.axis },
          '&.Mui-focused': { background: HEX.card },
          '&.Mui-focused fieldset': { borderColor: HEX.mint, borderWidth: 2 },
        },
        input: { padding: '10px 12px' },
      },
    },
    // No padding override here — SelectField/PillSelect own their box so a select
    // is exactly as tall as a text input beside it.
    MuiInputLabel: { styleOverrides: { root: { display: 'none' } } },
    MuiMenuItem: { styleOverrides: { root: { fontSize: 13 } } },
  },
});

export const CARD_SX = {
  background: 'var(--card)',
  border: '1px solid var(--border)',
  borderRadius: 'var(--radius)',
  boxShadow: SHADOW,
};

export default theme;
